<template>
    <transition name="fade" tag="v-layout" class="row wrap">
        <v-flex xs12 v-if="loading">
            <v-progress-linear :indeterminate="true"></v-progress-linear>
        </v-flex>
        <transition name="fade" mode="out-in">
        <v-flex xs12 v-if="!loading">
            <v-card flat>
                <v-card-title class="primary white--text headline">
                    Overview
                    <v-spacer></v-spacer>
                    <date-range-selector v-model="dateRange"  @change="handleDateChange()"></date-range-selector>
                </v-card-title>
                <v-layout row wrap>
                    <v-flex xs12>
                    </v-flex>
                    <v-flex xs12>
                        <v-layout row wrap>
                            <v-flex xs12 md6>
                                <v-data-table
                                        :headers="headers"
                                        disable-initial-sort
                                        :items="faults"
                                        :rows-per-page-items="[7,14,{'text':'$vuetify.dataIterator.rowsPerPageAll','value':-1}]"
                                >
                                    <template v-slot:items="props">
                                        <td class="text-xs-left">{{ props.item.title }}</td>
                                        <td class="text-xs-left">{{ props.item.equipment_name }}</td>
                                        <td class="text-xs-left">{{ props.item.equipment_type }}</td>
                                        <td class="text-xs-left">{{ props.item.floor }}</td>
                                        <td class="text-xs-left">{{props.item.start_date}}</td>
                                        <td class="text-xs-left">{{props.item.end_date}}</td>
                                        <td class="justify-center layout px-0">
                                            <v-icon
                                                    small
                                                    @click="jumpToLink(props.item)"
                                            >
                                                fa-chart-line
                                            </v-icon>
                                        </td>
                                    </template>
                                </v-data-table>
                            </v-flex>
                            <v-flex xs12 md6>
                                <v-layout row wrap>
                                    <v-flex xs12 md6>
                                        <vue-plotly v-if="faultPieData1" disable-responsive :data="faultPieData1"
                                                    :layout="faultPieLayout1" :options="{}" @click="jumpToNotification($event,'severity')"/>
                                    </v-flex>
                                    <v-flex xs12 md6>
                                        <vue-plotly v-if="faultPieData2" disable-responsive :data="faultPieData2"
                                                    :layout="faultPieLayout2" :options="{}" @click="jumpToNotification($event,'severity')"/>
                                    </v-flex>
                                </v-layout>

                            </v-flex>
                            <v-flex xs12 md6>
                                <v-layout row wrap>
                                    <v-flex xs12 md4>
                                        <vue-plotly v-if="pumpOnData" disable-responsive :data="pumpOnData" :layout="pumpOnLayout" :options="{}"/>
                                    </v-flex>
                                    <v-flex xs12 md4>
                                        <vue-plotly v-if="ahuOnData" disable-responsive :data="ahuOnData" :layout="ahuOnLayout" :options="{}"/>
                                    </v-flex>
                                    <v-flex xs12 md4>
                                        <vue-plotly v-if="roomTempData" disable-responsive :data="roomTempData" :layout="roomTempLayout" :options="{}"/>
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                            <v-flex xs12 md6>
                                <vue-plotly v-if="spaceHeatmapData" disable-responsive :data="spaceHeatmapData"
                                            :layout="spaceHeatmapLayout" :options="{}"/>
                            </v-flex>
<!--                            <v-flex v-for="plot in plotList" :key="'ms2'+plot.id"  xs12 md6 >-->
<!--                                <multi-plot-chart ref="plots" v-if="plot.type==='multi-chart'"-->
<!--                                                  :date-range="plot.config['range'] ? plot.config['range'] : refinedRange"-->
<!--                                                  :variable-x="plot.config['variable-x']"-->
<!--                                                  :variables-list="plot.config['variables-list']"-->
<!--                                                  :layout-overrides="plot.config['layout-overrides']"-->
<!--                                                  :type="plot.config['type']"-->
<!--                                                  just-plot-->
<!--                                ></multi-plot-chart>-->
<!--                                <data2-chart ref="plots" v-if="plot.type==='data2-chart'"-->
<!--                                             :layout-overrides="plot.config['layout-overrides']"-->
<!--                                             :x-axis="plot.config['x-axis']"-->
<!--                                             :data-payload="plot.config['data-payload']"-->
<!--                                             :series-overrides="plot.config['series-overrides']"-->
<!--                                             just-plot :date-range="plot.config['range'] ? plot.config['range'] : refinedRange"></data2-chart>-->
<!--                            </v-flex>-->
                        </v-layout>
                    </v-flex>
                </v-layout>
            </v-card>
        </v-flex>
        </transition>
    </transition>
</template>

<script>

    import moment from 'moment'
    import {callAPI,getNotification} from '@/helper'
    import VuePlotly from "../../components/VuePlotly";
    import MultiPlotChart from "../../components/MultiPlotChart";
    import Data2Chart from "../../components/Data2Chart";
    import DateRangeSelector from "../../components/DateRangeSelector";


    export default {
        name: 'AADashboard',
        components: {VuePlotly,MultiPlotChart,Data2Chart,DateRangeSelector},
        computed: {
            facility_name() {
                return this.$store.state.pointsListStore.facility_name
            },
            plotList() {
                return [
                    {
                        'id': 49646,
                        'type': 'data2-chart',
                        'config': {
                            'layout-overrides': {
                                title:'VFD Control',
                                xaxis: {
                                    title: "Date "
                                },
                                legend: {
                                    orientation: 'h',
                                    y:-0.2
                                },
                                margin:{
                                    l: 50,
                                    r: 50,
                                    t: 30,
                                    pad: 1
                                },

                            },
                            'data-payload': {
                                'filters': {
                                    'sensor_names': ["VFD_Control"],
                                    "equipment_type_regex": "^ahu",
                                }
                            },
                        }
                    },
                    {
                        'id': 54,
                        'type': 'multi-chart',
                        'config': {
                            'layout-overrides': {
                                title:"Chilled Water Temperature",
                                xaxis: {
                                    title: "Time "
                                },
                                yaxis: {
                                    title: "Temperature (°C)"
                                },
                                legend: {
                                    orientation: 'h',
                                    y:-0.2
                                },
                                margin:{
                                    l: 50,
                                    r: 50,
                                    t: 30,
                                    pad: 1
                                },
                            },
                            'variables-list': [
                                {
                                    equipment_name: "Header_SCP",
                                    facility_name: this.facility_name,
                                    name: "CHWR_Temp",
                                },
                                {
                                    equipment_name: "Header_SCP",
                                    facility_name: this.facility_name,
                                    name: "CHWS_Temp",
                                }

                            ],
                        }
                    },
                    {
                        'id': 4856,
                        'type': 'multi-chart',
                        'config': {
                            'layout-overrides': {
                                title:"Flow Rate",
                                xaxis: {
                                    title: "Time "
                                },
                                yaxis: {
                                    title: "Flow Rate (L/s)"
                                },
                                legend: {
                                    orientation: 'h',
                                    y:-0.2
                                },
                                margin:{
                                    l: 50,
                                    r: 50,
                                    t: 30,
                                    pad: 1
                                },
                            },
                            'variables-list': [
                                {
                                    equipment_name: "Header_SCP",
                                    facility_name: this.facility_name,
                                    name: "CHW_Flow_Rate",
                                }
                            ],
                        }
                    },
                    {
                        'id': 1,
                        'type': 'data2-chart',
                        'config': {
                            'layout-overrides': {
                                title:'VFD Control',
                                xaxis: {
                                    title: "Date "
                                },
                                legend: {
                                    orientation: 'h',
                                    y:-0.2
                                },
                                margin:{
                                    l: 50,
                                    r: 50,
                                    t: 30,
                                    pad: 1
                                },
                            },
                            'data-payload': {
                                'filters': {
                                    'sensor_names': ["VFD_Control"],
                                    "equipment_type": "SCP",
                                }
                            },
                        }
                    },
                    {
                        'id': 53432,
                        'type': 'data2-chart',
                        'config': {
                            'layout-overrides': {
                                title:'Pumps on',
                                xaxis: {
                                    title: "Date "
                                },
                                legend: {
                                    orientation: 'h',
                                    y:-0.2
                                },
                                margin:{
                                    l: 50,
                                    r: 50,
                                    t: 30,
                                    pad: 1
                                },
                            },
                            'data-payload': {
                                'filters': {
                                    'sensor_names': ["on"],
                                    "equipment_type": "SCP",
                                }
                            },
                            'series-overrides':{
                                stackgroup: 'one',
                                mode: 'none',
                            },
                        }
                    }
                ]
            }
        },
        data () {
            return {
                menu:false,
                baseDate:  moment().subtract(1, "days"),
                endDate:  moment().subtract(1, "days"),
                dateRange:  {start:moment().subtract(1, "days").format("YYYY-MM-DD"),end:moment().subtract(1, "days").format("YYYY-MM-DD")},
                refinedRange:  null,
                loading:true,
                severityColors:{
                    critical:'rgb(148, 103, 189)',
                    low:'rgb(188, 189, 34)',
                    medium:'rgb(255, 127, 14)',
                    high:'rgb(214, 39, 40)',
                },
                chillers:[],
                pumps:[],
                ahus:[],
                headers: [
                    {
                        text: 'Issue',
                        align: 'left',
                        sortable: true,
                        value: 'title'
                    },
                    {text: 'Equipment', value: 'equipment_name'},
                    {text: 'Equipment Type', value: 'equipment_type'},
                    {text: 'Floor', value: 'floor'},
                    {text: 'Start Date', value: 'start_date'},
                    {text: 'End Date', value: 'end_date'},
                    {text: 'Actions', value: 'name', sortable: false}
                ],
                faults:[],
                faultPieData1:null,
                faultPieData2:null,
                faultPieLayout1:{
                    title:"Fault severity",
                    legend: {
                        orientation: 'h',
                        x: 0.1
                    },
                    margin:{
                        l: 20,
                        r: 20,
                        b: 20,
                        t: 50,
                        pad: 1
                    },
                },
                faultPieLayout2:{
                    title:"Fault breakdown",
                    legend: {
                        orientation: 'h',
                        x:0.1
                    },
                    margin:{
                        r: 20,
                        b: 20,
                        t: 50,
                        pad: 1
                    },
                },
                roomTempData:null,
                spaceHeatmapData:null,
                spaceHeatmapLayout:{
                    title:"Space Temperature Trend (°C)",
                    yaxis: {
                        autotick: false,
                    },
                    margin:{
                        l: 100,
                        r: 20,
                        b: 40,
                        t: 50,
                        pad: 1
                    },
                },
                roomTempLayout:{
                    title:"Mean Space Temperature (°C)",
                    showlegend:false,
                    hovermode: 'closest',
                    xaxis: {
                        showgrid:false,
                        ticks:'',
                        showticklabels:false
                    },
                    yaxis: {
                    },
                    margin:{
                        l: 30,
                        r: 20,
                        b: 20,
                        t: 100,
                        pad: 1
                    },
                },
                ahuOnData:null,
                pumpOnData:null,
                ahuOnLayout:{
                    title:"AHU Run Time (hr)",
                    showlegend:false,
                    hovermode: 'closest',
                    xaxis: {
                        showgrid:false,
                        ticks:'',
                        showticklabels:false
                    },
                    margin:{
                        l: 30,
                        r: 20,
                        b: 20,
                        t: 100,
                        pad: 1
                    },
                },pumpOnLayout:{
                    title:"Pump Run Time (hr)",
                    showlegend:false,
                    hovermode: 'closest',
                    xaxis: {
                        showgrid:false,
                        ticks:'',
                        showticklabels:false
                    },
                    margin:{
                        l: 30,
                        r: 20,
                        b: 20,
                        t: 100,
                        pad: 1
                    },
                },
                chillerOnData:null,
                chilerOnLayout:{
                    title:"Chiller Run Time (hr)",
                    hovermode: 'closest',
                    showlegend:false,
                    xaxis: {
                        showgrid:false,
                        ticks:'',
                        showticklabels:false
                    },
                    margin:{
                        l: 20,
                        r: 20,
                        b: 20,
                        t: 50,
                        pad: 1
                    },
                },


            }
        },

        methods:{
            jumpToNotification(data,facet) {
              let output = {
                        path: '/notification-breakdown',
                  query:{
                      rangeStart: this.baseDate.startOf('day').format('YYYY-MM-DD HH:mm:ss'),
                      rangeEnd: this.endDate.endOf('day').format('YYYY-MM-DD HH:mm:ss'),
                  }
                    }
                output.query[facet]=data.points[0].label
              this.$router.push(output)
            },
            jumpToLink(item) {
                let output = null;
                if (item.title.substring(0,7) === "Anomaly") {
                    output = {
                        path: '/modelsummary',
                        query: {
                            rangeStart: item.to.query.rangeStart,
                            rangeEnd: item.to.query.rangeEnd,
                            equipment: item.equipment_name
                        }
                    }
                } else {
                    output = {
                        path: '/fault-analysis',
                        query: {
                            relevantVariables: item.to.query.variableX,
                            faultName: item.title,
                            faultDesc: item.description,
                            rangeStart: item.to.query.rangeStart,
                            rangeEnd: item.to.query.rangeEnd,
                            equipmentName: item.equipment_name
                        }
                    }
                }

                this.$router.push(output)
                // this.$store.dispatch('updateMaintenanceItem', this.getMaintenanceItem(item))
                // this.$router.push(item.to)
            },
            addArrays(ar1, ar2){
                let ar3 = [];
                for(let i in ar1)
                    if(!ar2[i]){
                        ar3.push(ar1[i]);
                    } else {
                        ar3.push(ar1[i] + ar2[i]);
                    }
                return ar3;
            },
            handleDateChange(){
                this.baseDate = moment(this.dateRange.start)
                this.endDate = moment(this.dateRange.end)
                this.getData()
            },
            getData(){
                let me=this;
                me.loading=true
                me.chillers=[]
                me.pumps=[]
                me.ahus=[]
                let currentRange=[me.baseDate.startOf('day').format('YYYY-MM-DD HH:mm:ss'),me.endDate.endOf('day').format('YYYY-MM-DD HH:mm:ss')]
                me.refinedRange={
                    start:currentRange[0],
                    end:currentRange[1],
                }
                for (let i in this.$store.state.pointsListStore.pointsList.equipment_details) {
                    let equip = this.$store.state.pointsListStore.pointsList.equipment_details[i]
                    if(equip.equipment_type.toLowerCase().startsWith('chiller')){
                        me.chillers.push(equip.equipment_name)
                    } else if(equip.equipment_type.toLowerCase().startsWith('ahu')){
                        me.ahus.push(equip.equipment_name)
                    } else if (equip.equipment_type==="SCP"){
                        me.pumps.push(equip.equipment_name)
                    }
                }
                me.ahus.sort()
                if(me.ahus.length>0) {
                    callAPI('data2/',
                        {
                            'filters': {
                                'facility_name': me.$store.state.pointsListStore.pointsList.facility_name,
                                'equipment_type_regex': 'ecfan|ahu',
                                'sensor_names': ['SA_Fan_Status', 'Space_Temp'],
                                'date_range': currentRange,
                            }
                        }
                    ).then(function (ahuRes) {
                        let timestamp = ahuRes.data.timestamp
                        let increm = 1 / me.$store.state.pointsListStore.pointsList.sampling_freq
                        let ahuNames = []
                        let ahuSpaceTemps = []
                        let ahuOn = []
                        let ahuTemps = []
                        for (let ahuName of me.ahus) {
                            if (ahuRes.data[ahuName + ' - SA_Fan_Status']&&ahuRes.data[ahuName + ' - Space_Temp']) {
                                let ahuTempArray = []
                                ahuNames.push(ahuName)
                                ahuSpaceTemps.push(ahuRes.data[ahuName + ' - Space_Temp'])
                                let ontime = 0
                                for (let flowindex in ahuRes.data[ahuName + ' - SA_Fan_Status']) {
                                    let flow = ahuRes.data[ahuName + ' - SA_Fan_Status'][flowindex]
                                    if (flow > 0) {
                                        ontime = ontime + increm
                                        if (ahuRes.data[ahuName + ' - Space_Temp']) {
                                            ahuTempArray.push(ahuRes.data[ahuName + ' - Space_Temp'][flowindex])
                                        }
                                    }
                                }
                                ahuOn.push(ontime)
                                ahuTemps.push(ahuTempArray.reduce((p, c) => p + c, 0) / ahuTempArray.length)
                            }
                        }
                        me.ahuOnData = [{
                            x: ahuNames,
                            y: ahuOn,
                            type: 'scatter',
                            mode: 'markers',
                            marker: {
                                symbol: 'circle',
                                size: 10
                            }
                        }]
                        me.roomTempData = [{
                            x: ahuNames,
                            y: ahuTemps,
                            type: 'scatter',
                            mode: 'markers',
                            marker: {
                                symbol: 'circle',
                                size: 10
                            }
                        }]
                        let colorscaleValue = [
                            [0, process.env.VUE_APP_THEME=='dark' ? "rgb(31, 119, 180)" : '#0000FF'],
                            [1, process.env.VUE_APP_THEME=='dark' ? "rgb(214, 39, 40)" : '#FF0000']
                        ]
                        me.spaceHeatmapData = [{
                            x: timestamp,
                            y: ahuNames,
                            z: ahuSpaceTemps,
                            type: 'heatmap',
                            mode: 'markers',
                            colorscale: colorscaleValue,
                        }]
                        me.loading=false;
                    })
                }
                if(me.pumps.length>0) {
                    callAPI('data2/',
                        {
                            'filters': {
                                'facility_name': me.$store.state.pointsListStore.pointsList.facility_name,
                                'equipment_type': 'SCP',
                                'sensor_names': ['on'],
                                'date_range': currentRange,
                            }
                        }
                    ).then(function (pumpRes) {
                        let increm = 1 / me.$store.state.pointsListStore.pointsList.sampling_freq
                        let pumpNames = []
                        let pumpOn = []
                        for (let pump of me.pumps) {
                            if (pumpRes.data[pump + ' - on']) {
                                pumpNames.push(pump)
                                let ontime = 0
                                for (let flowindex in pumpRes.data[pump + ' - on']) {
                                    let flow = pumpRes.data[pump + ' - on'][flowindex]
                                    if (flow > 0) {
                                        ontime = ontime + increm

                                    }
                                }
                                pumpOn.push(ontime)
                            }
                        }
                        me.pumpOnData = [{
                            x: pumpNames,
                            y: pumpOn,
                            type: 'scatter',
                            mode: 'markers',
                            marker: {
                                symbol: 'circle',
                                size: 10
                            }
                        }]

                    })
                }
                getNotification({
                    facility_name: this.$store.state.pointsListStore.pointsList.facility_name,
                    date_range:currentRange,
                }).then(function(notifResult) {
                    let rangeFaults = notifResult.result
                    let cpFaultSeverity = { }
                    let cpFaultTopic = { }
                    for (let fault of rangeFaults){
                        if(!cpFaultSeverity[fault.severity]){
                            cpFaultSeverity[fault.severity]=1
                        } else {
                            cpFaultSeverity[fault.severity]=cpFaultSeverity[fault.severity]+1
                        }
                        if(!cpFaultTopic[fault.topic]){
                            cpFaultTopic[fault.topic]=1
                        } else {
                            cpFaultTopic[fault.topic]=cpFaultTopic[fault.topic]+1
                        }
                    }
                    let faultEquip = { }
                    for (let fault of rangeFaults){
                        if(!faultEquip[fault.equipment_type]){
                            faultEquip[fault.equipment_type]=1
                        } else {
                            faultEquip[fault.equipment_type]=faultEquip[fault.equipment_type]+1
                        }
                    }
                    me.faults=rangeFaults.sort((a, b) => (a.end_date < b.end_date) ? 1 : -1);
                    let faultPieData1={
                        type: 'pie',
                        hole: .7,
                        labels: [],
                        marker: {
                            colors:[],
                        },
                        values: []
                    }
                    for (let severity in cpFaultSeverity){
                        faultPieData1.labels.push(severity)
                        faultPieData1.marker.colors.push(me.severityColors[severity])
                        faultPieData1.values.push(cpFaultSeverity[severity])
                    }
                    me.faultPieData1=[faultPieData1];
                    let fddRepData=[]
                    let faultsByType={
                        'Pumps':rangeFaults.filter(x=>x.equipment_type=="SCP"),
                        'AHUs':rangeFaults.filter(x=>x.equipment_type.toLowerCase().startsWith("ahu")),
                    }
                    for (let faultType in faultsByType){
                        let part={
                            x:[],
                            y:[],
                            name: faultType,
                            type: 'bar',
                            orientation: 'h'
                        }
                        for (let severity in cpFaultSeverity){
                            part.y.push(severity)
                            part.x.push(faultsByType[faultType].filter(x=>x.severity===severity).length)
                        }
                        fddRepData.push(part)
                    }
                    me.faultPieData2=fddRepData;
                })


            }

        },
        beforeMount() {
            let maxDate=this.$store.state.pointsListStore.pointsList.data_max_date;
            if(maxDate){
                this.baseDate=moment(maxDate).subtract(1, "days")
                this.endDate=moment(maxDate).subtract(1, "days")
                this.dateRange={start:this.baseDate.format('YYYY-MM-DD'),end:this.endDate.format('YYYY-MM-DD')}
            }
            this.getData();
        }



    }
</script>
